<template>
    <svg
        enable-background="new 0 0 64 64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
    >
        <g>
            <path d="m32 64c15 0 27.1-12.2 27.1-27.1 0-11.3-7-21.1-16.9-25.1l-3.6 5c8.4 2.8 14.6 10.8 14.6 20.1 0 11.7-9.5 21.2-21.2 21.2s-21.2-9.5-21.2-21.2c0-9.4 6.1-17.3 14.6-20.1l-3.6-5c-10 4-16.9 13.7-16.9 25.1 0 14.9 12.1 27.1 27.1 27.1z" />
            <path d="m27.4 16.2 1.9 2.6 2.7-.2 2.7.2 1.9-2.6 3.7-5.2 4.4-6-4.1-5h-8.6-8.6l-4.1 5 4.4 6z" />
        </g>
    </svg>
</template>
